"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPackageColorVariable = exports.PACKAGES = exports.FEATURED_WEEKS_FALLBACK_IMAGE = exports.FEATURED_WEEKS = void 0;
var _constants = require("../constants");
var FEATURED_WEEKS_LIST = {
  PECHE: [1240, 1284],
  APPLEBUM: [1232],
  RAW: [1247, 1288],
  VIBRAS: [1236, 1289],
  DRUMCODE: [1262],
  ULTRA: [1249, 1297],
  SARDINIA_REFINED: [1309],
  GREECE_BOOTCAMP: [1273],
  BVI_NEW_YEAR: [1280]
};
var FEATURED_WEEKS_FALLBACK_IMAGE = exports.FEATURED_WEEKS_FALLBACK_IMAGE = {
  url: 'https://assets.theyachtweek.com/wp-content/uploads/2018/03/TYW_W1_Asa.Steinars_189.jpg',
  alt: 'Fallback'
};
var FEATURED_WEEKS = exports.FEATURED_WEEKS = {};
FEATURED_WEEKS_LIST["PECHE"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/peche_logo.png',
      url_1: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/peche_black.png',
      alt: 'Peche'
    },
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/peche.jpg',
      alt: 'Peche in greece'
    },
    weekPill: {
      link: "https://www.theyachtweek.com/greece-peche",
      title: "House/Disco",
      icon: "info",
      iconColor: "#E06666"
    },
    featuredPill: {
      link: "https://www.theyachtweek.com/greece-peche",
      title: "Peche",
      icon: "info",
      iconColor: "#E06666"
    },
    addressBookId: _constants.ADDRESS_BOOKS["peche-week-signup"]
  };
});
FEATURED_WEEKS_LIST["APPLEBUM"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/Applebum-logo.png',
      alt: 'Applebum'
    },
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/applebum.jpeg',
      alt: 'Applebum in greece'
    },
    weekPill: {
      link: "https://www.theyachtweek.com/greece-applebum",
      title: "HIP HOP",
      icon: "info",
      iconColor: "#FF00FF"
    },
    featuredPill: {
      link: "https://www.theyachtweek.com/greece-applebum",
      title: "Applebum",
      icon: "info",
      iconColor: "#FF00FF"
    }
  };
});
FEATURED_WEEKS_LIST["RAW"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/rwsquare.png',
      url_1: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/raw_black.png',
      alt: 'Rhythm & Waves'
    },
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/rw.jpg',
      alt: 'Rhythm and Waves on Yacht Week'
    },
    weekPill: {
      link: null,
      title: "Dancehall/Hip Hop",
      icon: " info",
      iconColor: "#FF9900"
    },
    featuredPill: {
      link: null,
      title: "Rhythm and Waves",
      icon: "info",
      iconColor: "#FF9900"
    },
    addressBookId: _constants.ADDRESS_BOOKS["raw-week-signup"]
  };
});
FEATURED_WEEKS_LIST["VIBRAS"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: null,
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2023/09/vibras.jpg',
      alt: 'Vibras in greece'
    },
    weekPill: {
      link: "https://www.theyachtweek.com/vibras",
      title: "Latin / REGGAETON",
      icon: "info",
      iconColor: "#6AA84F"
    },
    featuredPill: {
      link: "https://www.theyachtweek.com/vibras",
      title: "Vibras",
      icon: "info",
      iconColor: "#6AA84F"
    },
    addressBookId: _constants.ADDRESS_BOOKS["vibras-week-signup"]
  };
});
FEATURED_WEEKS_LIST["DRUMCODE"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: {
      url: "https://assets.theyachtweek.com/wp-content/uploads/2023/12/drumcode_logo.png",
      alt: "Drumcode logo"
    },
    image: {
      url: "https://assets.theyachtweek.com/wp-content/uploads/2023/12/W22-Max-Woxberg.jpeg",
      alt: "Drumcode festival"
    },
    weekPill: {
      link: "https://www.theyachtweek.com/drumcode",
      title: "Techno",
      icon: "info",
      iconColor: "#333333"
    },
    featuredPill: {
      link: "https://www.theyachtweek.com/drumcode",
      title: "Drumcode",
      icon: "info",
      iconColor: "#333333"
    }
  };
});
FEATURED_WEEKS_LIST["ULTRA"].forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: {
      url: "https://assets.theyachtweek.com/wp-content/uploads/2023/12/Ultra-Logo-2.png",
      alt: "Ultra logo"
    },
    image: {
      url: "https://assets.theyachtweek.com/wp-content/uploads/2023/12/ultra.jpg",
      alt: "ultra festival"
    },
    weekPill: {
      link: null,
      tooltip: 'Ultra Festival tickets available',
      title: "VIP Tickets inc.",
      icon: "ticket",
      iconColor: "#9900FF"
    },
    featuredPill: {
      link: null,
      tooltip: 'Ultra Festival tickets available',
      title: "Ultra",
      icon: "ticket",
      iconColor: "#9900FF"
    },
    addressBookId: _constants.ADDRESS_BOOKS["ultra-week-signup"]
  };
});
FEATURED_WEEKS_LIST.SARDINIA_REFINED.forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: null,
    image: {
      url: 'https://assets.theyachtweek.com/wp-content/uploads/2024/07/Greece-James-Patrick-4.jpg',
      alt: 'Yachts on Yacht Week in sardinia'
    },
    weekPill: {
      link: null,
      tooltip: null,
      title: "Refined",
      icon: null,
      iconColor: '#079473'
    },
    featuredPill: {
      link: null,
      tooltip: null,
      title: "Refined",
      icon: null,
      iconColor: '#079473'
    },
    addressBookId: _constants.ADDRESS_BOOKS["sardinia-refined-signup"]
  };
});
FEATURED_WEEKS_LIST.GREECE_BOOTCAMP.forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: null,
    weekPill: {
      ink: null,
      tooltip: null,
      title: "PART-INCLUSIVE",
      icon: null,
      iconColor: '#079473'
    }
  };
});
FEATURED_WEEKS_LIST.BVI_NEW_YEAR.forEach(function (id) {
  FEATURED_WEEKS[id] = {
    logo: null,
    weekPill: {
      type: _constants.PILL_TYPES.BVI,
      ink: null,
      tooltip: null,
      title: "NEW YEARS EVE",
      icon: null,
      iconColor: '#009696'
    },
    featuredPill: {
      type: _constants.PILL_TYPES.BVI,
      ink: null,
      tooltip: null,
      title: "NEW YEARS EVE",
      icon: null,
      iconColor: '#009696'
    }
  };
});
var PACKAGES = exports.PACKAGES = {
  CLASSIC: 1,
  PREMIUM: 2,
  LUXURY: 3,
  LUXURY_PLUS: 4,
  CLASSIC_MONO: 5,
  CLASSIC_CAT: 6,
  PREMIUM_MONO: 7,
  PREMIUM_CAT: 8
};
var getPackageColorVariable = exports.getPackageColorVariable = function getPackageColorVariable(ratingId) {
  switch (ratingId) {
    case PACKAGES.CLASSIC:
      return "var(--color-classic)";
    case PACKAGES.CLASSIC_MONO:
      return "var(--color-classic-mono)";
    case PACKAGES.PREMIUM:
      return "var(--color-premium)";
    case PACKAGES.CLASSIC_CAT:
      return "var(--color-classic-cat)";
    case PACKAGES.LUXURY:
      return "var(--color-luxury)";
    case PACKAGES.PREMIUM_MONO:
      return "var(--color-premium-mono)";
    case PACKAGES.LUXURY_PLUS:
      return "var(--color-luxury-plus)";
    case PACKAGES.PREMIUM_CAT:
      return "var(--color-premium-cat)";
    default:
      return "var(--color-white)";
  }
};